import React, { useEffect, useRef } from 'react';

interface MessageContextMenuProps {
  x: number;
  y: number;
  isOwn: boolean;
  onForward: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
}

const MessageContextMenu: React.FC<MessageContextMenuProps> = ({ x, y, isOwn, onForward, onEdit, onDelete, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const style: React.CSSProperties = {
    position: 'fixed',
    left: Math.min(x, window.innerWidth - 200),
    top: Math.min(y, window.innerHeight - 150),
    zIndex: 9999,
  };

  return (
    <div ref={ref} style={style} className="bg-[#1a1d24] border border-gray-700 rounded-xl shadow-2xl py-1 w-48">
      <button
        onClick={() => { onForward(); onClose(); }}
        className="w-full px-4 py-2.5 text-left text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition flex items-center gap-2"
      >
        <span>↪️</span>
        <span>Переслать</span>
      </button>
      {isOwn && (
        <>
          <button
            onClick={() => { onEdit(); onClose(); }}
            className="w-full px-4 py-2.5 text-left text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition flex items-center gap-2"
          >
            <span>✏️</span>
            <span>Редактировать</span>
          </button>
          <button
            onClick={() => { onDelete(); onClose(); }}
            className="w-full px-4 py-2.5 text-left text-sm text-red-400 hover:bg-gray-800 hover:text-red-300 transition flex items-center gap-2"
          >
            <span>🗑️</span>
            <span>Удалить</span>
          </button>
        </>
      )}
    </div>
  );
};

export default MessageContextMenu;
